import { render, staticRenderFns } from "./DraggableChip.vue?vue&type=template&id=51f457b4"
import script from "./DraggableChip.vue?vue&type=script&lang=js"
export * from "./DraggableChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f457b4')) {
      api.createRecord('51f457b4', component.options)
    } else {
      api.reload('51f457b4', component.options)
    }
    module.hot.accept("./DraggableChip.vue?vue&type=template&id=51f457b4", function () {
      api.rerender('51f457b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/draggable-chip/DraggableChip.vue"
export default component.exports